export const lastDashboardNavigationCookieName = "lastDashboardNavigation"
